import { render, staticRenderFns } from "./HelperFooter.vue?vue&type=template&id=0ff9828b&scoped=true"
import script from "./HelperFooter.vue?vue&type=script&lang=js"
export * from "./HelperFooter.vue?vue&type=script&lang=js"
import style0 from "./HelperFooter.vue?vue&type=style&index=0&id=0ff9828b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9828b",
  null
  
)

export default component.exports